module.exports = __webpack_public_path__ + "static/img/empty_1.9c584383.png";